import { render, staticRenderFns } from "./TicketStatusHistory.html?vue&type=template&id=27c920fb&scoped=true&external"
import script from "./TicketStatusHistory.vue?vue&type=script&lang=js"
export * from "./TicketStatusHistory.vue?vue&type=script&lang=js"
import style0 from "./TicketStatusHistory.scss?vue&type=style&index=0&id=27c920fb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c920fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimeline,VTimelineItem})
